export const Types = {
  CURRENT_LOGGED_IN_USER: "CURRENT_LOGGED_IN_USER",
  VALIDATE_USER: "VALIDATE_USER",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAIL: "LOGIN_FAIL",
  REDIRECT: "REDIRECT",
  LOG_OUT: "LOG_OUT",
};